import {
    FieldResponseError,
    FormControl,
    FormValidationResult,
    FormValidationRule,
    FormValidationRuleWithState,
    FormValues,
    GravityResponse
} from "./types";

import { evaluates_as_hiddenV2 } from "./conditional-logic";
import { getControlProps } from "./form-context";

const validateControl = (
    rules: (FormValidationRule | FormValidationRuleWithState)[],
    control: FormControl,
    state: { controls: React.ReactNode[]; values: FormValues, response?: GravityResponse }
) => {
    const fieldResponseErrors: Array<string> = [];
    const responseErrors:
        { [key: string]: FieldResponseError } | undefined = state.response?.validationMessages;
    if (responseErrors && control.name in responseErrors && !responseErrors[control.name].isEdited) {
        fieldResponseErrors.push(responseErrors[control.name].error);
    }
    return rules.reduce((errors: Array<string>, rule) => {
        const [valid, error] = rule(control, state.values[control.name], state);
        if (!valid && typeof error === "string") {
            errors.push(error);
        }

        return errors;
    }, fieldResponseErrors);
};

const isControlHidden = (
    control: { [key: string]: any },
    state: { controls: React.ReactNode[]; values: FormValues }
) => {
    const section = control.section ?? { conditionalLogic: null };
    return (
        evaluates_as_hiddenV2(section.conditionalLogic, state) ||
        evaluates_as_hiddenV2(control.conditionalLogic, state)
    );
};

const validationReducer = (
    rules: (FormValidationRule | FormValidationRuleWithState)[],
    state: { controls: React.ReactNode[]; values: FormValues, response?: GravityResponse }
) => (
    formerrors: { [key: string]: Array<string> },
    control: { [key: string]: any }
) => {
    const controlerrors = !isControlHidden(control, state)
        ? validateControl(rules, control as FormControl, state)
        : [];

    if (controlerrors.length) {
        formerrors[control.name] = controlerrors;
    }
    return formerrors;
};

const validate = (
    rules: (FormValidationRule | FormValidationRuleWithState)[],
    controls: React.ReactNode[],
    state: { controls: React.ReactNode[]; values: FormValues, response?: GravityResponse }
): FormValidationResult => {
    const errors = Object.values(getControlProps(controls)).reduce(
        validationReducer(rules, state),
        {}
    );

    return errors;
};

export { validate };
